<template>
  <div class="bom-usage-skeleton">
    <div v-for="n in rows" :key="n" class="bom-usage-skeleton__row">
      <div class="bom-usage-skeleton__left">
        <div class="bom-usage-skeleton__icon skeleton"></div>
        <div class="bom-usage-skeleton__text">
          <div class="bom-usage-skeleton__line skeleton line-lg"></div>
          <div class="bom-usage-skeleton__line skeleton line-sm"></div>
        </div>
      </div>
      <div class="bom-usage-skeleton__right">
        <div class="bom-usage-skeleton__line skeleton line-md"></div>
        <div class="bom-usage-skeleton__line skeleton line-xs"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BomUsageSkeleton',
  props: {
    rows: {
      type: Number,
      default: 3
    }
  }
}
</script>

<style lang="scss" scoped>
.bom-usage-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 14px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #fafafa;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  &__icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 140px;
  }

  &__right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    min-width: 80px;
  }
}

.skeleton {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.3s ease infinite;
  border-radius: 6px;
}

.line-lg {
  width: 180px;
  height: 12px;
}

.line-md {
  width: 70px;
  height: 12px;
}

.line-sm {
  width: 140px;
  height: 10px;
}

.line-xs {
  width: 60px;
  height: 10px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
